import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'

import { useInitData } from '../../../../hooks'
import {
  AddressSelectFormikField,
  toAddressSelectItemFromReverseGeocode,
} from '../../../Address'
import { GoogleMap } from '../../GoogleMap'
import { FIELD_ADDRESS_NAME } from '../GoogleMapModal.constants'
import { useManageBuildingMarker } from '../GoogleMapModal.hooks'
import {
  getGoogleMapModalBuildingMarker,
  getGoogleMapModalCenter,
} from '../GoogleMapModal.utils'

function FormFields({ addressSelectProps, editMode }) {
  const { t } = useTranslation()

  const {
    uk: { city: currentCity },
  } = useInitData()

  const { setFieldValue, values } = useFormikContext()

  const mapCenter = getGoogleMapModalCenter(
    values?.[FIELD_ADDRESS_NAME],
    currentCity
  )

  const { buildingMarker: currentBuildingMarker, handleMapClick } =
    useManageBuildingMarker({
      editMode,
      initialMarker: getGoogleMapModalBuildingMarker(
        values?.[FIELD_ADDRESS_NAME]
      ),
    })

  function handleChangeAddress(value) {
    setFieldValue(
      FIELD_ADDRESS_NAME,
      toAddressSelectItemFromReverseGeocode(value)
    )
  }

  return (
    <>
      <AddressSelectFormikField
        {...addressSelectProps}
        withEntityCreationFromSearchValue
        controlProps={{
          contentProps: {
            inputProps: {
              placeholder: t('Input.AddressPlaceholderKey'),
            },
          },
        }}
        listProps={{
          Footer: null,
        }}
        name={FIELD_ADDRESS_NAME}
      />

      <GoogleMap
        defaultCenter={mapCenter}
        editMode={editMode}
        markers={currentBuildingMarker ? [currentBuildingMarker] : null}
        onChangeAddress={handleChangeAddress}
        onMapClick={handleMapClick}
      />
    </>
  )
}

export default FormFields
